import React, { useState } from 'react'
import { Collapse } from 'antd'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { handleAction, handleSave } from './utils'
import { CollapseBody, ExtraPanel } from './components'
import { GENERAL } from 'modules/core/constants'
import Typography from 'modules/core/components/Typography/Typography'
import configuration from 'modules/configuration'
import planning from 'modules/planning'
import PropTypes from 'prop-types'
import { sendUserDataToGTM } from 'modules/core/utils'
import login from 'modules/login'

const { Panel } = Collapse

const CollapseRules = ({
  ruleList,
  canCreate,
  onRefetch,
  onRefetchRules,
  applyRule,
  unApplyRule,
  disabled,
  setVariablesValues,
  saveVariableValues,
  typeModule = GENERAL.MODULES_KEYS.MODULE_PLANNING,
  moduleId = 0,
  setShowAlert,
  selectRule,
  setSelectRule,
  action,
  loggedUser,
}) => {
  const [variableId, setVariableId] = useState(null)
  const [showPopconfirm, setShowPopconfirm] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  let { periodId } = useParams()
  const { t } = useTranslation()

  const onCreate = (ruleId, variable) => {
    setVariablesValues({
      ruleId,
      variableId: variable.id,
      dataVariable: { originValues: variable.values },
    })
    return saveVariableValues(ruleId, variable.id, {
      period: periodId,
      value_by_month: variable.values,
      type: typeModule,
      pk: moduleId,
    })
  }

  const renderPanel = (rule) => {
    return (
      <Panel
        collapsible={rule.whereApplied === 'PORCENTAJE' ? 'disabled' : '-'}
        header={rule.name}
        key={rule.id}
        extra={
          <ExtraPanel
            disabled={
              !canCreate ||
              disabled ||
              rule.variables.some(
                (data) => JSON.stringify(data.values) !== JSON.stringify(data.originValues),
              )
            }
            onChange={(checked) => {
              const auxAction = checked ? () => applyRule(rule.id) : () => unApplyRule(rule.id)
              const text = checked
                ? t('RULES_APPLY_TEXT').toLowerCase()
                : t('RULES_UNAPPLY_TEXT').toLowerCase()
              handleAction({
                setIsLoading: setIsSaving,
                action: auxAction,
                onRefetchRules,
                text,
                onClose: () => setIsSaving(false),
                setShowAlert,
                sendUserDataToGTM: () =>
                  sendUserDataToGTM(
                    loggedUser,
                    'Reglas',
                    `${checked ? 'Aplcar' : 'Desaplicar'} regla`,
                    `${checked ? 'Aplcación' : 'Desaplicación'}`,
                  ),
              })
            }}
            loading={isSaving}
            isApplied={rule.isApplied}
            onChangeCheckbox={(val) => setSelectRule([...selectRule, rule.id])}
            action={action}
            checked={selectRule.includes(rule.id)}
          />
        }
      >
        {renderPanelBody(rule)}
      </Panel>
    )
  }

  const renderCollapseVariable = (variable, rule) => {
    return (
      <Collapse accordion key={variable.id}>
        <Panel header={variable.name} key={variable.id}>
          <CollapseBody
            values={variable.values}
            originValues={variable.originValues}
            disableInput={!canCreate || disabled}
            onChangeInput={(val, month) =>
              setVariablesValues({
                ruleId: rule.id,
                variableId: variable.id,
                dataVariable: { values: { ...variable.values, [month]: val } },
              })
            }
            onChangePopConfirm={() => {
              setVariablesValues({
                ruleId: rule.id,
                variableId: variable.id,
                dataVariable: { values: variable.originValues },
              })
              setShowPopconfirm(false)
              setVariableId(null)
            }}
            onCancelPopConfirm={() => {
              setShowPopconfirm(false)
              setVariableId(null)
            }}
            visiblePopconfirm={variable.id === variableId && showPopconfirm}
            disableCnacel={isSaving}
            onClickCancel={() => {
              setShowPopconfirm(true)
              setVariableId(variable.id)
            }}
            onClickSave={() =>
              handleSave({
                setIsLoading: setIsSaving,
                saveVariableValues: () => onCreate(rule.id, variable),
                onClose: () => setIsSaving(false),
                setShowAlert,
                sendUserDataToGTM: () =>
                  sendUserDataToGTM(loggedUser, 'Reglas', `Guardar valores regla`, `Guardado`),
              })
            }
            loading={isSaving}
            disableSave={variable.id === variableId && showPopconfirm}
          />
        </Panel>
      </Collapse>
    )
  }

  const renderPanelBody = (rule) => {
    return (
      <>
        <Typography.Body>{`${t('LABEL_FORMULA')} : ${rule.formula.slice(7)}`}</Typography.Body>
        {rule.variables.map((variable) => renderCollapseVariable(variable, rule))}
      </>
    )
  }

  return (
    <Collapse accordion>
      {ruleList.map((rule) => {
        return renderPanel(rule)
      })}
    </Collapse>
  )
}

const mapStateToProps = (state) => ({
  loggedUser: login.selectors.getWhoAmI(state),
})

const mapDispatchToProps = {
  setVariablesValues: configuration.actions.setVariablesValues,
  saveVariableValues: planning.actions.saveVariableValues,
}

CollapseRules.propTypes = {
  ruleList: PropTypes.array,
  canCreate: PropTypes.bool,
  onRefetch: PropTypes.func,
  onRefetchRules: PropTypes.func,
  applyRule: PropTypes.func,
  unApplyRule: PropTypes.func,
  disabled: PropTypes.bool,
  setVariablesValues: PropTypes.func,
  saveVariableValues: PropTypes.func,
  typeModule: PropTypes.string,
  moduleId: PropTypes.number,
  setShowAlert: PropTypes.func,
  selectRule: PropTypes.array,
  setSelectRule: PropTypes.func,
  action: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(CollapseRules)
